import React from 'react';
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  description?: string;
  inverted?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  description,
  inverted = false
}: SectionHeadingProps) {
  return <header className="mx-auto max-w-2xl text-center" data-id="element-17">
      <p className={`inline-flex rounded-full px-3 py-1 text-[10px] font-black tracking-[0.14em] ${inverted ? 'bg-sky-400/15 text-sky-300' : 'bg-blue-100 text-blue-800'}`} data-id="element-18">
        {eyebrow}
      </p>
      <h2 className={`mt-2.5 text-3xl font-black leading-[1.05] tracking-[-0.04em] sm:mt-3 sm:text-4xl ${inverted ? 'text-white' : 'text-slate-950'}`} data-id="element-19">
        {title}
      </h2>
      {description && <p className={`mt-3 text-sm leading-6 sm:mt-4 ${inverted ? 'text-slate-300' : 'text-slate-600'}`} data-id="element-20">
          {description}
        </p>}
    </header>;
}